// installPrompt.js

export const handleInstallPrompt = () => {
    let deferredPrompt;
  
    window.addEventListener('beforeinstallprompt', (e) => {
      // Previne o comportamento padrão
      e.preventDefault();
      // Guarda o evento para ser acionado mais tarde
      deferredPrompt = e;
  
      // Exibe o botão de instalação
      const installButton = document.getElementById('install-button');
      installButton.style.display = 'block';
  
      installButton.addEventListener('click', () => {
        // Exibe o prompt de instalação
        deferredPrompt.prompt();
  
        // Lida com a resposta do usuário
        deferredPrompt.userChoice.then((choiceResult) => {
          if (choiceResult.outcome === 'accepted') {
            console.log('Usuário aceitou instalar');
          } else {
            console.log('Usuário recusou instalar');
          }
          deferredPrompt = null;
        });
      });
    });
  };
  